module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/employer/registration.component.css
// module id = ./src/app/views/employer/registration.component.css
// module chunks = main